import { CapacitorContacts } from '@capgo/capacitor-contacts';

export const useContacts = () => {
  const isContactFeatureEnabled = false;

  const getContacts = async () => {
    const contacts = await CapacitorContacts.getContacts();
    return contacts;
  };

  return { isContactFeatureEnabled, getContacts };
};
